/* eslint-disable */
import React from 'react';
import { Box, IconButton, InputBase } from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import { useTranslation } from 'react-i18next';
import { AppMessenger } from 'utils';
import { FOCUS_CHAT } from 'widgetActions';
import { useStyles } from './styles';

const initialValueState = '';

export default function MessageComposer({ handleSend, isSendingMsg }) {
	const { t } = useTranslation();
	const [value, setValue] = React.useState(initialValueState);
	const classes = useStyles();

	const disableSend = value.trim().length === 0 || isSendingMsg;

	const handleSendClick = () => {
		if (!disableSend) {
			handleSend({ text: value });
			setValue(initialValueState);
		}
	};

	return (
		<Box className={classes.container}>
			<Box className={classes.messageComposerBox}>
				<InputBase
					className={classes.inputField}
					aria-label={t('type_your_message', 'Type your message')}
					placeholder={t('type_your_message', 'Type your message...')}
					onKeyDown={(e) => {
						if (e.key === 'Enter' && !e.shiftKey) {
							e.preventDefault();
							handleSendClick();
						}
					}}
					onChange={(e) => setValue(e.target.value)}
					type="text"
					value={value}
					fullWidth
					multiline
					minRows={1}
					maxRows={4}
					autoFocus
					onFocus={() => {
						AppMessenger.sendMessageToWidget({
							action: FOCUS_CHAT,
						});
					}}
				/>
				<IconButton
					onClick={() => handleSendClick()}
					color="primary"
					aria-label={t('send', 'send')}
					disabled={disableSend}
					className={classes.iconBtn}
				>
					<SendIcon color="inherit" />
				</IconButton>
			</Box>
		</Box>
	);
}
